<template>
    <div v-if="show" class="mask1 flex flex-center-sp flex-center-cz">
        <div class="loader"></div>
    </div>

</template>

<script>
     export default {
        name:'Loading',
        data() {
            return {
                show: false
            }
        },
        methods:{
            init() {
                this.show = true;
            },
            close() {
                console.log("close")
                this.show = false;
            }
        }
     }
</script>

<style scoped>

    /* loading样式 */ 
    .loader {
        border: 10px solid #f3f3f3;
        border-radius: 50%;
        border-top: 10px solid #36a4fd;
        width: 45px;
        height: 45px;
        -webkit-animation: spin 2s linear infinite;
        animation: spin 2s linear infinite;
    }
    
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }



</style>


// WEBPACK FOOTER //
// src/components/loading/Loading.vue